module.exports = {};



//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/babel-polyfill/~/core-js/modules/_iterators.js
// module id = 179
// module chunks = 0